export function PdfColored() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_8821_87240)">
				<path
					d="M2.99999 0H15.7447L22.5 6.72902V22.5C22.5 23.3287 21.828 24 21 24H2.99999C2.17196 24 1.5 23.3287 1.5 22.5V1.49999C1.5 0.671265 2.17204 0 2.99999 0Z"
					fill="#E2574C"
				/>
				<path
					d="M22.4783 6.74997H17.25C16.422 6.74997 15.7501 6.07801 15.7501 5.24999V0.0149774L22.4783 6.74997Z"
					fill="#B53629"
				/>
				<path
					d="M16.8735 11.3722C17.1248 11.3722 17.2478 11.1532 17.2478 10.941C17.2478 10.7212 17.1195 10.509 16.8735 10.509H15.4425C15.1628 10.509 15.0068 10.7407 15.0068 10.9965V14.5132C15.0068 14.8267 15.1853 15.0007 15.4268 15.0007C15.6668 15.0007 15.8461 14.8267 15.8461 14.5132V13.548H16.7116C16.9801 13.548 17.1143 13.3282 17.1143 13.11C17.1143 12.8963 16.9801 12.684 16.7116 12.684H15.8461V11.3722H16.8735ZM12.0368 10.509H10.9897C10.7055 10.509 10.5037 10.704 10.5037 10.9935V14.5162C10.5037 14.8755 10.794 14.988 11.0017 14.988H12.1005C13.4009 14.988 14.2597 14.1323 14.2597 12.8115C14.259 11.415 13.4505 10.509 12.0368 10.509ZM12.087 14.1195H11.4488V11.3775H12.024C12.8948 11.3775 13.2735 11.9618 13.2735 12.768C13.2735 13.5225 12.9015 14.1195 12.087 14.1195ZM8.25153 10.509H7.21429C6.92103 10.509 6.75752 10.7024 6.75752 10.9965V14.5132C6.75752 14.8267 6.945 15.0007 7.19698 15.0007C7.44896 15.0007 7.63645 14.8267 7.63645 14.5132V13.4864H8.28668C9.08917 13.4864 9.75143 12.9179 9.75143 12.0037C9.75151 11.109 9.11253 10.509 8.25153 10.509ZM8.2343 12.6615H7.63652V11.3348H8.2343C8.6033 11.3348 8.83805 11.6227 8.83805 11.9985C8.83727 12.3735 8.6033 12.6615 8.2343 12.6615Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_8821_87240">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
